export default __webpack_public_path__ + "static/media/gr.3eeff25c.svg";